import React from 'react'

import { ComponentType, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import BackendError from 'aem-libs-react-ts/src/components/BackendError'
import { IStore } from 'aem-libs-react-ts/src/store'
import DynamicParamsPromise from 'aem-libs-react-ts/src/services/DynamicParamsPromise'
import { setParamsDynamic, setError } from 'aem-libs-react-ts/src/store/Store'

const contextSelector = (store: IStore) => store.context

const EmptyComponent = () => {
  return <></>
}

type CallBack = () => void
type AsyncCallBack = () => Promise<any>

const useInitApp = (RootElement: ComponentType, callback: CallBack | AsyncCallBack) => {
  const { appSpinner, error } = useSelector(contextSelector)
  const [resolved, setResolved] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    const callInit = async () => {
      try {
        await callback()
      } catch (e) {
        dispatch(setError(true))
      } finally {
        setResolved(true)
        appSpinner.hide()
      }
    }
    callInit()
  }, [])

  if (error) {
    return BackendError
  }

  if (!resolved) {
    return EmptyComponent
  }

  return RootElement
}

export { useInitApp }
